import { render, staticRenderFns } from "./CountyLogoAndTitle.vue?vue&type=template&id=2081f518"
import script from "./CountyLogoAndTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./CountyLogoAndTitle.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports